import React from 'react';

export const LazySmartDeviceManagementPage = React.lazy(() => import('./ManagementPage'));
export const LazySmartDeviceDistributionPage = React.lazy(() => import('./DistributionPage'));
export const LazySmartDeviceAlertHistoryPage = React.lazy(() => import('./AlertHistoryPage'));
export const LazySmartDeviceEnvironmentSensorManagementPage = React.lazy(
  () => import('./GasManagementPage')
);
